import { WorkOpportunitiesTab } from "../constants";
import { FiltersData } from "../contexts/marketplace_context.types";
import { StartDateCondition } from "../hooks/use_start_date_filter";
import { getTabFilters } from "./get_tab_filters";

export const getMatchingActivitiesFilters = (
  filtersData: FiltersData,
  isUnreadOnly: boolean,
  startDate?: StartDateCondition | null
) => {
  const matchingActivitiesFilters = getTabFilters(filtersData, WorkOpportunitiesTab.MatchingRoles);

  return {
    ...matchingActivitiesFilters,
    fields: {
      ...matchingActivitiesFilters?.fields,
      ...(isUnreadOnly ? { readStatus: false } : {}),
      ...(startDate
        ? {
            start_date: {
              end: startDate.to,
              start: startDate.from
            }
          }
        : {})
    }
  };
};
